import { useEffect } from 'react';

const REDUCED_MOTION_CSS = `
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
`;

/**
 * Applies global a11y enhancements: smooth scroll, reduced-motion preference, keyboard-focus class.
 */
export const useAccessibilityPrefs = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.documentElement.style.scrollBehavior = 'auto';
      const style = document.createElement('style');
      style.textContent = REDUCED_MOTION_CSS;
      document.head.appendChild(style);
    }

    const onKeydown = (e) => {
      if (e.key === 'Tab') document.body.classList.add('keyboard-navigation');
    };
    const onMousedown = () => document.body.classList.remove('keyboard-navigation');

    document.addEventListener('keydown', onKeydown);
    document.addEventListener('mousedown', onMousedown);

    return () => {
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('mousedown', onMousedown);
    };
  }, []);
};
